import { render, staticRenderFns } from "./Myway.vue?vue&type=template&id=a77126dc&lang=pug"
import script from "./Myway.vue?vue&type=script&lang=coffee"
export * from "./Myway.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports